<template>
	<div>
		<transition name="expand">
			<carrier-selection-modal
				v-if="showCarrierSelectionModal"
				:zone="editZone"
				:carriers="tenantCarriers"
				:modified-carrier-zones="modifiedCarrierZones"
				:lcr="editLcr"
				@close="closeCarrierSelection"
				@save="savedZone"
			/>
		</transition>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/lcrs"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="!editLcr.name || !editLcr.tenant"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editLcr.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/lcrs')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"></div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">LCR Configuration</h3>
									</div>
									<div class="mb-2 md:mb-5">
										<div class="mx-auto w-full px-2">
											<div class="formGroup">
												<label class="textGrey">Name</label>
												<FormKit
													v-model="editLcr.name"
													type="text"
													class="form-control"
													placeholder="LCR Name"
													name="LCR Name"
													:validation="'required'"
													validation-visibility="live"
												/>
											</div>
										</div>
									</div>
									<div
										v-if="
											!editLcr.id &&
											(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
										"
										class="mx-auto mb-2 w-full md:mb-5"
									>
										<div class="w-full px-2">
											<div class="formGroup withIcon">
												<label class="textGrey">Tenant</label>
												<select v-model="editLcr.tenant" required>
													<option :value="null">-- Unassigned --</option>
													<option v-for="t in tenants" :key="t.id" :value="t">
														{{ t.companyName }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_1 || !editLcr.default_carrier_1 === null
															? `/carriers/${editLcr.default_carrier_1.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_1 || !editLcr.default_carrier_1 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #1</label
													>
													<svg
														v-if="
															editLcr.default_carrier_1 ||
															!editLcr.default_carrier_1 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_1">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_2 || !editLcr.default_carrier_2 === null
															? `/carriers/${editLcr.default_carrier_2.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_2 || !editLcr.default_carrier_2 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #2</label
													>
													<svg
														v-if="
															editLcr.default_carrier_2 ||
															!editLcr.default_carrier_2 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_2">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_3 || !editLcr.default_carrier_3 === null
															? `/carriers/${editLcr.default_carrier_3.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_3 || !editLcr.default_carrier_3 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #3</label
													>
													<svg
														v-if="
															editLcr.default_carrier_3 ||
															!editLcr.default_carrier_3 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_3">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_4 || !editLcr.default_carrier_4 === null
															? `/carriers/${editLcr.default_carrier_4.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_4 || !editLcr.default_carrier_4 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #4</label
													>
													<svg
														v-if="
															editLcr.default_carrier_4 ||
															!editLcr.default_carrier_4 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_4">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="mx-auto mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_5 || !editLcr.default_carrier_5 === null
															? `/carriers/${editLcr.default_carrier_5.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_5 || !editLcr.default_carrier_5 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #5</label
													>
													<svg
														v-if="
															editLcr.default_carrier_5 ||
															!editLcr.default_carrier_5 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_5">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div v-if="editLcr.tenant" class="w-1/2 px-2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editLcr.default_carrier_6 || !editLcr.default_carrier_6 === null
															? `/carriers/${editLcr.default_carrier_6.id}`
															: 'javascript:void(0);'
													"
													:target="
														editLcr.default_carrier_6 || !editLcr.default_carrier_6 === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>Default Carrier #6</label
													>
													<svg
														v-if="
															editLcr.default_carrier_6 ||
															!editLcr.default_carrier_6 === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editLcr.default_carrier_6">
													<option :value="null">-- Unassigned --</option>
													<option v-for="c in tenantCarriers" :key="c.id" :value="c">
														{{ c.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div v-if="editLcr.tenant" class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Search and Filter</h3>
									</div>
									<div
										v-if="editLcr.tenant"
										class="mx-auto mb-2 flex w-full flex-wrap items-center justify-center gap-2 px-2 md:justify-start"
									>
										<div class="formGroup w-full min-w-52 md:w-1/3">
											<input
												id="search_box"
												v-model="searchEntry"
												type="text"
												placeholder="Search"
											/>
										</div>
										<div
											class="formGroup ml-4 flex flex-col items-center justify-center md:flex-row"
										>
											<label for="showModified" class="w-40 text-center"
												>Show Only Modified ({{ modifiedZoneCount }})</label
											>
											<input
												id="showModified"
												v-model="showOnlyModifiedCarriers"
												type="checkbox"
												class="tw-toggle ml-2 border-none bg-transparent"
											/>
										</div>
										<div
											class="formGroup ml-4 flex flex-col items-center justify-center md:flex-row"
										>
											<label for="showSelected" class="w-40 text-center"
												>Show Only Selected ({{ selectedZoneCount }})</label
											>
											<input
												id="showSelected"
												v-model="showOnlySelectedCarriers"
												type="checkbox"
												class="tw-toggle ml-2 border-none bg-transparent"
											/>
										</div>
										<div class="flex flex-wrap items-center justify-center gap-2 sm:flex-nowrap">
											<div
												class="formGroup flex flex-col items-center justify-center md:flex-row"
											>
												<button class="jmiBtn orange whitespace-nowrap" @click="selectAll()">
													Select All
												</button>
											</div>
											<div
												class="formGroup flex flex-col items-center justify-center md:flex-row"
											>
												<button class="jmiBtn red whitespace-nowrap" @click="unselectAll()">
													Unselect All
												</button>
											</div>
										</div>
									</div>
									<div v-if="editLcr.tenant" class="row margin-b20 w-full px-2">
										<div
											v-for="zone in filteredZoneNames"
											:key="zone"
											class="col-sm-6 col-md-3 col-lg-3 mr-4 sm:mr-0"
										>
											<div class="formGroup checkbox">
												<label :class="{ fontHeavy: hasCustomCarriers(zone) }"
													><input
														type="checkbox"
														class="mr-0.5"
														:value="zone"
														:checked="isZoneAllowed(zone)"
														@change="zoneChanged($event, zone)"
													/>
													{{ zone }}</label
												>
												<span
													v-if="isZoneAllowed(zone)"
													class="margin-l5 fa-light fa-small fa-light fa-pencil"
													@click="showCarrierSelection(zone)"
												></span>
												<span
													v-if="hasCustomCarriers(zone)"
													class="margin-l5 fa-light fa-small fa-light fa-close"
													@click="resetCustomZone(zone)"
												>
												</span>
											</div>
										</div>
									</div>
									<div class="row margin-b20 w-full px-2">
										<div class="w-full">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="!editLcr.name || !editLcr.tenant"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editLcr.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/lcrs')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import lcrsApi from '../scripts/lcrs/lcrs.api.js'
import carriersApi from '../scripts/carriers/carriers.api.js'
import tariffCodesApi from '../scripts/tariffcodes/tariffcodes.api.js'
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editLcr: {
				name: '',
				tenant: null,
				default_carrier_1: null,
				default_carrier_2: null,
				default_carrier_3: null,
				default_carrier_4: null,
				default_carrier_5: null,
				default_carrier_6: null,
				allowed_destinations: []
			},
			carriers: [],
			zoneNames: [],
			showCarrierSelectionModal: false,
			editZone: null,
			showOnlyModifiedCarriers: false,
			showOnlySelectedCarriers: false,
			searchEntry: '',
			loading: true
		}
	},

	computed: {
		tenantCarriers() {
			return JSON.parse(JSON.stringify(this.carriers))
				.filter((c) => c.tenant?.id === this.editLcr.tenant?.id)
				.map((c) => {
					delete c.tenant
					return c
				})
				.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
		},
		selectedZoneCount() {
			return this.editLcr.allowed_destinations ? this.editLcr.allowed_destinations.length : 0
		},
		modifiedZoneCount() {
			return this.editLcr.allowed_destinations
				? this.editLcr.allowed_destinations.filter((z) => z.carrier_selection || z.send_to_app?.selectedApp)
						.length
				: 0
		},
		filteredZoneNames() {
			let filtered = this.zoneNames
			if (this.searchEntry) {
				filtered = filtered.filter((z) => z.toLowerCase().includes(this.searchEntry.toLowerCase()))
			}
			if (this.showOnlyModifiedCarriers) {
				filtered = filtered.filter((z) => this.hasCustomCarriers(z))
			}
			if (this.showOnlySelectedCarriers) {
				filtered = filtered.filter((z) => this.isZoneAllowed(z))
			}
			return filtered
		},
		modifiedCarrierZones() {
			return this.editLcr.allowed_destinations.filter((z) => z.carrier_selection?.carrier1)
		}
	},

	async mounted() {
		try {
			const carriersResult = carriersApi.getAll()
			const tariffCodesResult = tariffCodesApi.getAllZoneNames()

			if (this.$route.params.id !== 'new') {
				this.reload(this.$route.params.id)
			} else if (this.tenants?.length === 1) this.editLcr.tenant = this.tenants[0]

			this.carriers = (await carriersResult).data.results
			this.zoneNames = (await tariffCodesResult).data.results
			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading LCR',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/lcrs')
			})
			console.error(e)
		}
	},

	methods: {
		closeCarrierSelection() {
			this.showCarrierSelectionModal = false
		},
		savedZone(data) {
			if (data && data.zone_name) {
				let zone = this.editLcr.allowed_destinations.find((z) => z.zone_name === data.zone_name)
				if (zone) {
					if (!zone.carrier_selection || data.selectedApp) zone.carrier_selection = {}

					if (data?.selectedApp) {
						zone.send_to_app = zone.send_to_app || {}
						zone.send_to_app.selectedApp = data.selectedApp
						zone.send_to_app.app_config = data.app_config
					} else if (data?.carrier1) {
						zone.carrier_selection.carrier1 = data.carrier1.id
						if (data.carrier2) {
							zone.carrier_selection.carrier2 = data.carrier2.id
							if (data.carrier3) {
								zone.carrier_selection.carrier3 = data.carrier3.id
								if (data.carrier4) {
									zone.carrier_selection.carrier4 = data.carrier4.id
									if (data.carrier5) {
										zone.carrier_selection.carrier5 = data.carrier5.id
										if (data.carrier6) {
											zone.carrier_selection.carrier6 = data.carrier6.id
										}
									}
								}
							}
						}
					} else {
						zone.carrier_selection = null
						if (zone.send_to_app) zone.send_to_app.selectedApp = null
					}
				}
			}
			this.showCarrierSelectionModal = false
		},
		resetCustomZone(zone_name) {
			let zone = this.editLcr.allowed_destinations.find((z) => z.zone_name === zone_name)
			if (zone) {
				zone.carrier_selection = null
				if (zone.send_to_app) zone.send_to_app.selectedApp = null
			}
		},
		zoneChanged($event, zone_name) {
			if ($event.target.checked === true) {
				if (!this.editLcr.allowed_destinations) this.editLcr.allowed_destinations = []
				this.editLcr.allowed_destinations.push({
					zone_name
				})
			} else {
				this.editLcr.allowed_destinations = this.editLcr.allowed_destinations.filter(
					(z) => z.zone_name !== zone_name
				)
			}
		},
		reload(id) {
			lcrsApi.getById(id).then((result) => {
				this.editLcr = result.data
			})
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		selectAll() {
			this.editLcr.allowed_destinations = (this.editLcr.allowed_destinations || []).concat(
				this.filteredZoneNames.map((z) => ({ zone_name: z })).filter((z) => !this.isZoneAllowed(z.zone_name))
			)
		},
		unselectAll() {
			this.editLcr.allowed_destinations = this.editLcr.allowed_destinations.filter(
				(z) => !this.filteredZoneNames.includes(z.zone_name)
			)
		},
		showCarrierSelection(zone_name) {
			let zone = null

			if (this.editLcr && this.editLcr.allowed_destinations)
				zone = this.editLcr.allowed_destinations.find((z) => z.zone_name === zone_name)
			else return false

			this.editZone = zone

			this.showCarrierSelectionModal = true
		},
		hasCustomCarriers(zone_name) {
			if (this.editLcr && this.editLcr.allowed_destinations) {
				let zone = this.editLcr.allowed_destinations.find((z) => z.zone_name === zone_name)
				return (zone?.carrier_selection && zone?.carrier_selection.carrier1) || zone?.send_to_app?.selectedApp
			} else return false
		},
		isZoneAllowed(zone_name) {
			if (this.editLcr && this.editLcr.allowed_destinations) {
				let zone = this.editLcr.allowed_destinations.find((z) => z.zone_name === zone_name)
				return !!zone
			} else return false
		},
		save() {
			if (!this.editLcr.id) {
				lcrsApi
					.create(this.editLcr)
					.then((u) => {
						this.routeTo('/lcrs')
					})
					.catch(console.error)
			} else {
				lcrsApi
					.update(this.editLcr)
					.then((u) => {
						this.routeTo('/lcrs')
					})
					.catch(console.error)
			}
		}
	}
}
</script>
